import { createVanIconComponent } from "./van"

const ShopOutlined = createVanIconComponent("shop-o")
export default ShopOutlined
